import LocationTable from "./LocationTable";

const LocationTab = () => {
	return <LocationTable />;
};

export default LocationTab;
